import { Alerta, Buscar, SinSenal, Calendario } from './Iconos.jsx';

const ICONOS = { buscar: Buscar, alerta: Alerta, sinSenal: SinSenal, calendario: Calendario };

/**
 * Pantalla para todo lo que no es el camino feliz: vacíos, errores, sin
 * conexión. Nunca muestra un código HTTP ni un mensaje del servidor crudo.
 */
export function Estado({ icono = 'alerta', titulo, children, accion, etiquetaAccion, exito = false }) {
  const Icono = ICONOS[icono] ?? Alerta;

  return (
    <div className="estado" role="status">
      <div className={`estado-icono${exito ? ' exito' : ''}`}>
        <Icono />
      </div>
      <h2 className="estado-titulo">{titulo}</h2>
      {children}
      {accion && (
        <button type="button" className="boton boton-secundario" onClick={accion}>
          {etiquetaAccion}
        </button>
      )}
    </div>
  );
}
